import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const CopyContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const CopyCompanyContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '&>div.companySection': {
    display: 'flex',
    flexDirection: 'row',

    '>div>div.subTitle': {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      paddingBottom: '0.25rem',
      marginTop: '1rem',
      display: 'flex'
    },

    '>div.sourceCompany, >div.destinationCompany': {
      display: 'flex',
      flexDirection: 'column',
    },

    '>div.sourceCompany': {
      flex: 1,
      borderRight: 'solid 1px #CCC'
    },

    '>div.destinationCompany': {
      flex: 1,
      paddingLeft: '1rem'
    },
  },
})

export const CopyPurchasingOrgContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '&>div.purchasingOrgSection': {
    display: 'flex',
    flexDirection: 'row',

    '>div>div.subTitle': {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      paddingBottom: '0.25rem',
      marginTop: '1rem',
      display: 'flex'
    },

    '>div.sourceSection, >div.destinationSection': {
      display: 'flex',
      flexDirection: 'column',
    },

    '>div.sourceSection': {
      flex: 1,
      borderRight: 'solid 1px #CCC'
    },

    '>div.destinationSection': {
      flex: 1,
      paddingLeft: '1rem'
    },
  },
})

export const PurchasingOrgCellContainer = styled.div({
  display: 'flex',
  marginTop: '5px',
  padding: '8px',
  borderRadius: '5px',
  border: 'solid 1px #999',
  alignItems: 'center',
  cursor: 'pointer',

  input: {
    marginRight: '5px',
  },

  '&.disable': {
    border: 'solid 1px #CCC',
    color: '#CCC',
    cursor: 'default',
  },

  '&.selected': {
    border: `solid 1px ${v.ezMainColor}`,
  }
})